import {Button} from "@/components/ui/button";

interface MenuPopUpProps {
  top: number;
  onDisconnect: () => void;
}

const MenuPopUp = (props: MenuPopUpProps) => {
  const style = {
    position: "fixed" as const,
    top: props.top,
    right: 0,
    zIndex: 10,
    backgroundColor: "white",
    boxShadow: "3px 3px 10px",
    width: 180,
    transition: "all 0.5s ease",
  };

  return (
    <div id="MenuPopUp" style={style}>
      <Button
        className="w-full"
        size="sm"
        variant="secondary"
        onClick={props.onDisconnect}
      >
        Se déconnecter
      </Button>
    </div>
  );
};

export default MenuPopUp;
